import { createCompletionNotification, syncQueue, type CompletionInput } from '@auw/api-client';
import type { AgentCompletedData, Conversation } from '@auw/workspace-utils';
import { emitAppEvent } from './events';
import { useUserStore } from './userStore';

export function notifyCompletion(input: CompletionInput): void {
  const accountId = useUserStore.getState().user?.userId;
  if (!accountId) return;
  syncQueue.enqueue({
    key: `notification:${accountId}:${input.event_id}`,
    execute: async () => {
      if (useUserStore.getState().user?.userId !== accountId) return;
      await createCompletionNotification(input);
    },
    onSuccess: () => emitAppEvent('notifications:changed'),
  });
}

// Use the message_id sent to /run/stream (the server's run_id), never the
// separate assistant bubble ID. Both writers must share this idempotency key.
export function notifyConversationCompleted(conversation: Conversation, requestMessageId: string, data: AgentCompletedData): void {
  const mode = conversation.mode;
  if (!mode || !['agent', 'doc-agent', 'gtc-agent', 'purchase-agent'].includes(mode)
      || data.user_input_request || data.turn_outcome === 'awaiting_user_input'
      || data.document_edit_outcome === 'edit_failed'
      || data.document_mutation_result?.status === 'failed') return;
  const documentId = conversation.workspaceSettings?.docAgentDocumentId;
  notifyCompletion({
    event_id: `turn:${requestMessageId}`, workspace_type: mode as CompletionInput['workspace_type'],
    item_id: conversation.id,
    document_id: typeof documentId === 'string' ? documentId : undefined,
    title: String(conversation.workspaceSettings?.docAgentChatTitle || conversation.title || 'SOLA-COWORK').slice(0, 200),
  });
}
